<div class="skl-users-list" aria-busy="true" aria-label="Loading users">

  <!-- H1 -->
  <app-skeleton width="100px" height="28px" borderRadius="4px" marginBottom="20px" class="d-block"></app-skeleton>

  <!-- Table -->
  <div class="skl-table-wrap">
    <!-- Header row -->
    <div class="skl-row skl-header-row">
      @for (col of tableCols; track col) {
        <div class="skl-cell">
          <app-skeleton width="75%" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
      }
    </div>
    <!-- Data rows -->
    @for (row of tableRows; track row) {
      <div class="skl-row skl-data-row">
        @for (col of tableCols; track col) {
          <div class="skl-cell">
            <app-skeleton [width]="col === 1 ? '70%' : col === 2 ? '85%' : '55%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
          </div>
        }
      </div>
    }
  </div>

  <!-- Paginator -->
  <div class="skl-paginator">
    <app-skeleton width="200px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
    <div class="d-flex gap-1">
      @for (btn of [1,2,3,4]; track btn) {
        <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
      }
    </div>
  </div>

</div>
